<template>
  <div>
    <facit-header></facit-header>
    <div class="profile-div col-12">
      <h5 class="mt-3 mb-3">Usage History </h5>


      <div class="total-main-sec">
        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Exports - Today</p> <b style="font-size: 27px;">{{ exportToday }}</b>
        </div>

        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Exports - This Month</p> <b style="font-size: 27px;">{{ exportThisMonth }}</b>
        </div>

        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Exports - Last 12 Month</p> <b style="font-size: 27px;">{{ export12Month }}</b>
        </div>
		<div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Exports - Last 24 Month</p> <b style="font-size: 27px;">{{ export24Month }}</b>
        </div>
        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Videos Length</p> <b style="font-size: 27px;">{{ averageVideo }}</b>
        </div>
		<div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Loading Time</p> <b style="font-size: 27px;">{{ loadingTime }}</b>
        </div>
        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Processing Time</p> <b style="font-size: 27px;">{{ processTime }}</b>
        </div>
        <div class="total-sec" style="border: 1px solid;padding: 10px;">
          <p>Interaction Time</p> <b style="font-size: 27px;">{{ interactionTime }}</b>
        </div>

      </div>

      <b-row style="justify-content: space-between;">
        <div style="display: flex; gap: 10px; align-items: center; width: 430px; margin-left: 15px;">
		  <b-form-select
			@change="company($event)"
			v-model="selected"
			:options="allCompany"
			size="md"
			style="height: 35px; width: 200px;"
		  ></b-form-select>
		  <div style="display: flex; align-items: baseline; gap: 10px;">
			<label>Start date:</label>
			  <b-form-input
				v-model="endDate"
				type="date"
				style="height: 35px; width: 200px;"
				@change="getUpdatedDateData()"
			  ></b-form-input>
		  </div>
		  
		  <div style="display: flex; align-items: baseline; gap: 10px;">
			 <label>End date:</label>
			  <b-form-input
				v-model="startDate"
				type="date"
				style="height: 35px; width: 200px;"
				@change="getUpdatedDateData()"
			  ></b-form-input>
		  </div>
		</div>
        <div class="float-right my-1">
          <b-form-group horizontal label="" class="mb-3">
            <b-input-group>

              <div @click="exportData()">
                <v-icon style="cursor: pointer;position: relative;top: 10px;right: 15px;" name="download"
                  base-class="icon-width" @click="exportData()">
                </v-icon>
              </div>

              <b-form-input
      v-model="searchInput"
      placeholder="Search"
      
    />
    <b-btn class="clearBtn" :disabled="!searchInput" @click="clearFilter">Clear</b-btn>
            </b-input-group>
          </b-form-group>
        </div>
      </b-row>
      <b-table striped hover show-empty empty-text="There is no usage history to show" :fields="tableFields"
        :items="pagedHistory" :filter="filter"   :current-page="currentPage"  :per-page="perPage" @filtered="onFiltered">
		
			
		<template slot="analyticsslot" slot-scope="data">
           <div style="display: flex;justify-content: center;">
		  <i @click="getDetail(data.item.analytics)" title="Analytics">
              <v-icon v-b-tooltip.hover title="Analytics" style="cursor: pointer;" name="info" base-class="icon-width"
                @click="getDetail(data.item.analytics)">
              </v-icon>
            </i>
        </template>
		
      </b-table>
      <br>
      <b-pagination align="right" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />

	
	<b-modal v-model="analyticModal" hide-footer  title="Analytics" @hide="resetModal">
      <div>
        <pre><code> {{ analyticsData }}</code></pre>
      </div>
    </b-modal>

 <!--Edit Model-->

      <br><br>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';
import Session from '@/Session';
import numeral from 'vue-numeral-filter';
import { excelParser } from "../../excel-parser";

export default {
  name: 'loginHistory',
  components: { FacitHeader },
  data() {
    return {
      exportToday: 0,
      export12Month: 0,
	  export24Month:0,
      averageVideo: `00:00:00`,
      loadingTime: `00:00:00`,
      processTime: `00:00:00`,
      interactionTime: `00:00:00`,
      exportThisMonth: 0,
      exportFilterToday: 0,
      exportFilter12Month: 0,
	  exportFilter24Month:0,
      exportFilterMonth: 0,
      allCompany: ['All'],
      selected: 'All',
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: null,
	  analyticsData:null,
      userSettingsModal: false,
	  searchInput: "",
      filter: null,
	  analytics:'',
      listData: [],
      currentListData: null,
	  analyticModal : false,
      moment: moment,
      tableFields: [
        {
          key: 'firstname',
          label: 'First Name',
          sortable: true,
        },
        {
          key: 'lastname',
          label: 'Last Name',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email Address',
          sortable: true,
        },
        {
          key: 'mac',
          label: 'MAC Address',
          sortable: true,
        },
        {
          key: 'companyname',
          label: 'Company Name',
          sortable: true,
        },
        {
          key: 'timestamp',
          label: 'Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY HH:mm');
          },
        },
        {
          key: 'credit',
          label: 'Credit',
          sortable: true,
        },
        {
          key: 'length',
          label: 'Video Length',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: false,
        },
        {
          key: 'analyticsslot',
          label: 'Analytics'
        },
      ],
      startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),//moment({ year: moment().year(), month: 0, day: 1 }).format('YYYY-MM-DD'),//moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      totalVideoExport: 0,
      averageLength: 0,
      historyData: []
    };
  },
  async created() {
    const userId = this.$route.query.id;
	this.company(this.selected);
    this.getUsers11();
	
  },

  computed: {
    // computed filteredHistory ensures search always runs and is compatible with older build tools
    filteredHistory() {
      if (!this.history || this.history.length === 0) return [];
      if (!this.searchInput || this.searchInput.trim() === '') return this.history;

      const search = this.searchInput.trim().toLowerCase();

      return this.history.filter((item) => {
        const firstname = item.firstname ? String(item.firstname).toLowerCase() : '';
        const lastname = item.lastname ? String(item.lastname).toLowerCase() : '';
        const email = item.email ? String(item.email).toLowerCase() : '';
        const mac = item.mac ? String(item.mac).toLowerCase() : '';
        const companyname = item.companyname ? String(item.companyname).toLowerCase() : '';

        return (
          (firstname && firstname.indexOf(search) !== -1) ||
          (lastname && lastname.indexOf(search) !== -1) ||
          (email && email.indexOf(search) !== -1) ||
          (mac && mac.indexOf(search) !== -1) ||
          (companyname && companyname.indexOf(search) !== -1)
        );
      });
    },

    // slice for pagination
    pagedHistory() {
      return this.filteredHistory;
    }
  },

  watch: {
    // whenever filteredHistory changes update the counters and export list
    filteredHistory: {
      handler(newVal) {
        this.totalRows = newVal ? newVal.length : 0;
        // reuse your existing onFiltered logic
        try {
          this.onFiltered(newVal || []);
        } catch (e) {
          // swallow to avoid breaking UI
        }
      },
      immediate: true
    }
  },
  methods: {
   
   applyFilter() {
     this.searchInput = this.searchInput ? this.searchInput.trim() : '';
    },
    clearFilter() {
      this.searchInput = '';
      this.filter = '';
    },
  
    async company(companyName) {

      const numeral = require('numeral');
      let historyData = [];

      //this.history = await API.get('Accounts/?filter={"include":[{"relation": "historyExport","scope":{"order": "timestamp DESC"}},{"relation":"productkey"}]}');
	  
	  
	const end = new Date(this.endDate); 
	end.setUTCHours(23, 59, 59, 999); 
	const start = new Date(this.startDate); 
	start.setUTCHours(0, 0, 0, 0);

	this.history = await API.get(`Accounts/?filter=${encodeURIComponent(JSON.stringify({include: [{relation: "historyExport",scope: {where: {timestamp: { gte: start.toISOString(), lte: end.toISOString()}
                },order: "timestamp DESC"}},{ relation: "productkey" }]}))}`);
	  
	
	 let updateCompanyList = false;
	
	
      if (companyName != 'All') {
        this.history = await this.history.filter(h => {
          return h.historyExport.length > 0 && h.productkey.length > 0 && h.companyname == companyName
        }
        );
      } else {
        this.history = await this.history.filter(h => h.historyExport.length > 0 && h.productkey.length > 0);
		
		updateCompanyList = true;
      }

      this.exportThisMonth = 0;
      this.exportToday = 0;
      this.export12Month = 0;
   	  this.export24Month = 0;
      this.history = this.history.forEach(h => {
        h.historyExport.map(async (bh) => {
          let device = await h.productkey.find(d => d.productKey === bh.mac)
          const emailAddress = h.email
          const emailLast = emailAddress.split('@')
		  
		  
		  try {
            dd = new Date(bh.timestamp.split('T')[0].replace(/-/g, '\/'));
            dbTime = dd.getTime();
			if(dbTime > end) //lte not working so using this
				return;
          } catch (e) { }
		  
          // if (device && emailLast[1] != 'facitdatasystems.com' && emailAddress != 'waqas16@gmail.com' && emailAddress != 'engr.awais40@hotmail.com') {
          // try {
          bh.email = h.email
          bh.firstname = h.firstname
          bh.lastname = h.lastname
          bh.host = device ? device.hostName : ''
          bh.companyname = h.companyname
          bh.credit = numeral(h.credits).format('$ 0,0[.0]')
		  bh.mac = bh.mac.slice(0, 9)
		  
		  
          historyData.push(bh);
          // } catch (e) { }

          var today = new Date(new Date().toDateString());
          var priorDate = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toDateString());
          var last12Month = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), -365).toDateString());
          var last24Month = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), -730).toDateString());

          var dd;
          var dbTime;
          try {
            dd = new Date(bh.timestamp.split('T')[0].replace(/-/g, '\/'));
            dbTime = dd.getTime();
          } catch (e) { }
          if ((dbTime <= today.getTime()) && (dbTime >= priorDate.getTime())) {
            this.exportThisMonth += 1;
          }
          if (dbTime == new Date(new Date().toDateString()).getTime()) {
            this.exportToday += 1;
          }
          if ((dbTime <= today.getTime()) && (dbTime >= last12Month.getTime())) {
            this.export12Month += 1;
          }
          if ((dbTime <= today.getTime()) && (dbTime >= last24Month.getTime())) {
            this.export24Month += 1;
          }
        });
      });


      this.history = await historyData

      // sort data based on date
      function custom_sort(a, b) {
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
      }
      this.history.sort(custom_sort);
      ////////////////////////////////



// get distinct company_name

	if(updateCompanyList == true)
	{
	 const uniqueCompany = [...new Set(this.history.map(item => item.companyname))];

      this.allCompany = [];

      uniqueCompany.map((data) => {
        this.allCompany.push(data)
      })

      this.allCompany.sort();
      this.allCompany.unshift('All')
	}


      ////////////for video average length////////////

      this.avgVideoLength(this.history);

      /////////////////////////////////////////////

      ////////////////Processing Time//////////////

      this.processingTime(this.history);

      /////////////////////////////////////////////



      // For Export Excel File

      Object.assign(this.listData, this.history);

      this.listData = this.listData.map((res) => {
        return { 'First Name': res.firstname, 'Last Name': res.lastname, 'Email Address': res.email, 'MAC Address': res.mac, 'Company Name': res.companyname, 'Date': res.timestamp, 'Credit': res.credit, 'Video Length': res.length, 'Version': res.version ,'Analytics':res.analytics}
      })

      this.currentListData = this.history.slice(0, 10)

      this.totalRows = this.history.length;
	  

    },
    async getUsers11() {
      const token = Session.getAccessToken();
      const userId = token.user.id;
      this.historyData = await API.get(`/HistoryExports?filter={"where":{"clientId":"${userId}"}}`);
    },
    onFiltered(filteredItems) {
	
      // Trigger pagination to update the number of buttons/pages due to filtering

      this.exportFilterMonth = 0;
      this.exportFilterToday = 0;
      this.exportFilter12Month = 0;
      this.exportFilter24Month = 0;

      let historyData = [];

      let filterData = filteredItems

      filterData = filterData.forEach(bh => {

        try {
		  bh.mac = bh.mac.slice(0, 9);
          historyData.push(bh);
        } catch (e) { }

        var today = new Date(new Date().toDateString());
        var priorDate = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toDateString());
        var last12Month = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), -365).toDateString());
        var last24Month = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), -730).toDateString());

        // var dd = new Date(new Date(bh.timestamp).toDateString());
        // var userTimezoneOffset = dd.getTimezoneOffset() * 60000;
        // var dbTime = (dd.getTime() - userTimezoneOffset);

        var dd;
        var dbTime;
        try {
          dd = new Date(bh.timestamp.split('T')[0].replace(/-/g, '\/'));
          dbTime = dd.getTime();
        } catch (e) { }

        if ((dbTime <= today.getTime()) && (dbTime >= priorDate.getTime())) {
          this.exportFilterMonth += 1;
        }
        if (dbTime == new Date(new Date().toDateString()).getTime()) {
          this.exportFilterToday += 1;
        }
        if ((dbTime <= today.getTime()) && (dbTime >= last12Month.getTime())) {
          this.exportFilter12Month += 1;
        }
        if ((dbTime <= today.getTime()) && (dbTime >= last24Month.getTime())) {
          this.exportFilter24Month += 1;
        }
        

        this.exportThisMonth = this.exportFilterMonth;
        this.exportToday = this.exportFilterToday;
        this.export12Month = this.exportFilter12Month;
		this.export24Month= this.exportFilter24Month;

      });
      
	function custom_sort(a, b) {
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
      }
      historyData.sort(custom_sort);

      filterData = historyData

      ////////////for video average length////////////

      this.avgVideoLength(filterData);

      /////////////////////////////////////////////

      ////////////////Processing Time//////////////

      this.processingTime(filterData);

      /////////////////////////////////////////////

      // For Export Excel File
      // this.listData = filteredItems
      Object.assign(this.listData, filteredItems);

      this.listData = this.listData.map((res) => {
        return { 'First Name': res.firstname, 'Last Name': res.lastname, 'Email Address': res.email, 'MAC Address': res.mac, 'Company Name': res.companyname, 'Date': res.timestamp, 'Credit': res.credit, 'Video Length': res.length, 'Version': res.version ,'Analytics':res.analytics}
      })

      this.currentListData = filteredItems.slice(0, 10)

      this.totalRows = filteredItems.length;
    },
	resetModal() {
      this.analyticsData = null;
	   this.analyticModal = false;
    },
	getDetail(data) {
      // Handle the icon click event
	  //console.log(data);
	  try {
       this.analyticsData = JSON.stringify(JSON.parse(data),null,2);
	   // alert(JSON.stringify(JSON.parse(data),null,2));
      } catch (e) {
       // alert(data);
	   this.analyticsData =data;
      }
	  this.analyticModal = true;
      
    },
	async getUpdatedDateData(){
		//this.getHistory();
		//console.log(this.selected);
		this.company(this.selected);
	},
	
	
	
    async avgVideoLength(params) {

      let totalVideo = 0;
      this.averageVideo = `00:00:00`;

      const videoLen = params.filter((data, index) => {
        return data.length >= 0
      })

      videoLen.filter((res) => {
        totalVideo = totalVideo + res.length
      })

      if (videoLen.length <= 0) {
        this.processTime = `00:00:00`;
      } else {
        const videoHr = (totalVideo / (videoLen.length)).toFixed(1) * 60 * 1000;
        var seconds = videoHr / 1000
        var hours = parseInt(seconds / 3600) < 10 ? `0${parseInt(seconds / 3600)}` : parseInt(seconds / 3600); // 3,600 seconds in 1 hour
        seconds = seconds % 3600; // seconds remaining after extracting hours
        var minutes = parseInt(seconds / 60) < 10 ? `0${parseInt(seconds / 60)}` : parseInt(seconds / 60); // 60 seconds in 1 minute
        seconds = seconds % 60 < 10 ? `0${parseInt(seconds % 60)}` : parseInt(seconds % 60);
        this.averageVideo = `${hours}:${minutes}:${seconds}`
      }

    },
	async SecondsToTime(time,count){
		var seconds = (time / count);
        var hours = parseInt(seconds / 3600) < 10 ? `0${parseInt(seconds / 3600)}` : parseInt(seconds / 3600); // 3,600 seconds in 1 hour
        seconds = seconds % 3600; // seconds remaining after extracting hours
        var minutes = parseInt(seconds / 60) < 10 ? `0${parseInt(seconds / 60)}` : parseInt(seconds / 60); // 60 seconds in 1 minute
        seconds = seconds % 60 < 10 ? `0${parseInt(seconds % 60)}` : parseInt(seconds % 60);
		let timeCalculated = `${hours}:${minutes}:${seconds}`;
		return timeCalculated;
	},
    async processingTime(params) {
      let avgTime = 0;
	  let TotalInteractionTime =0;
	  let InteractionTimeCount = 0;
	  
	  
	  let TotalLoadingTime =0;
	  let LoadingTimeCount = 0;
	  
	  
	  let TotalProcessingTime =0;
	  let ProcessingTimeCount = 0;
	  
	  this.loadingTime = `00:00:00`;
      this.processTime = `00:00:00`;
	  this.interactionTime = `00:00:00`;
      
	   params.filter((data) => {
		let tmpSeconds = 0;
		try{
			if(data.analytics != null && data.analytics != "")
			{
				let json = JSON.parse(data.analytics);
				tmpSeconds = json.InteractionTime;
				if(tmpSeconds > 0)
				 {
  				   TotalInteractionTime = TotalInteractionTime+ tmpSeconds;
				   InteractionTimeCount = InteractionTimeCount + 1;
				 }
				 tmpSeconds = json.LoadingDuration;
				 if(tmpSeconds > 0)
				 {
					TotalLoadingTime = TotalLoadingTime + tmpSeconds;
					LoadingTimeCount = LoadingTimeCount + 1;
				 }
				 tmpSeconds = json.ProcessingDuration;
				 if(tmpSeconds > 0)
				 {
					TotalProcessingTime = TotalProcessingTime + tmpSeconds;
					ProcessingTimeCount = ProcessingTimeCount + 1;
				 }
				 
			 }
		}catch(err){
			//console.log(err);
		}
        
      })
	  
	  if(InteractionTimeCount == 0)
	  {
	   this.interactionTime = `00:00:00`;
	  }else{ 
        this.interactionTime = await this.SecondsToTime(TotalInteractionTime,InteractionTimeCount)
	  }
	  
	  if(ProcessingTimeCount == 0)
	  {
	   this.processTime = `00:00:00`;
	  }else{ 
	  
        this.processTime = await this.SecondsToTime(TotalProcessingTime,ProcessingTimeCount)
	  }
	  if(LoadingTimeCount == 0)
	  {
	   this.loadingTime = `00:00:00`;
	  }else{ 
        this.loadingTime = await this.SecondsToTime(TotalLoadingTime,LoadingTimeCount)
	  }
    },
    exportData() {
      excelParser().exportDataFromJSON(this.listData, null, null);
    },
    exportCurrentData() {
      excelParser().exportDataFromJSON(this.currentListData, null, null);
    },
    users() {
      this.$router.push('/admin/users');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-sec {
  margin: 10px;
}

.range-sec {
  border: 1px dashed #4e434378;
  margin: 20px 60px;
  padding: 20px 45px;
}

.highlights-sec {
  display: flex;
}

.week-sec {
  margin-right: 50px;
}

.week-sec ul {

  padding: 0;
  border-left: 1px solid #c7b3b378;
  border-right: 1px solid #c7b3b378;
}

.week-sec li {
  list-style-type: none;
  border-bottom: 1px solid #c7b3b378;
  width: 160px;
  padding: 3px 8px;
}

li:first-child {
  background: #c7b3b378;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fa-caret-down {
  font-size: 30px;
  color: orangered;
}

label {
  width: 80px;
}

.field-sec {
  position: relative;
  margin-bottom: 6px;
}

input {
  border: 1px solid #867c7c78;
  padding: 5px;
}

input::placeholder {
  color: #867c7c78;
}

.field-sec i {
  position: absolute;
  right: 15px;
  top: 6px;
}

.total-sec {
  text-align: center;
  margin-right: 35px;
}

.total-sec:last-child {
  margin-right: 0;
}

.total-sec h3 {
  color: orangered;
}

.total-sec h5 {
  padding-bottom: 10px;
  border-bottom: 3px solid orangered;
  color: #887e7e;
}

.total-main-sec {
  display: flex;

}

.history-main-sec {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.light-text {
  margin-bottom: 20px;
  color: #918585;
}

/* //////////////////////////////////////////////////////////////// */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: #d6700a;
}

input:focus+.slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}

.switch input {
  display: none;
}

.icon-width {
  width: 20px !important;
  height: 20px !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #6610f2 !important;
  border-color: #6610f2 !important;
}

.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}

.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}

.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/usageHistory.vue